<!-- =========================================================================================
    File Name: Home.vue
    Description: Home Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="vx-col sm:w-full md:w-full lg:w-full xl:w-full" >
        <div class="mt-5">
          <div class="horizon"></div>
          <span class="mt-2 back-arrow">
                <!-- <router-link :to="'/'"> -->
            <b-button
              type="filled"
              @click="hasHistory() 
    ? $router.go(-1) 
    : $router.push('/')"
              class="br-20"
                 :style="buttonCss"
              variant="info"
              ><i class="fa fa-chevron-left" aria-hidden="true"></i
            ></b-button>
            <!-- </router-link> -->
            <span class="ml-2 mr-2" :style="textColor"   
              ><i>{{ $t("Back") }}</i></span
            >
          </span>
        </div>
  </div>
</template>



<style lang="scss">
.br-20 {
  border-radius: 20px !important;
}
.br-10 {
  border-radius: 10px;
}
#document1{
   width: 100%;
  height: auto;
    opacity: 0.4;
    max-height: 500px;
  object-fit: contain;
}

.image-document{
  position: relative;
}
.button-center {
  position: relative;
  left: 47.5%;
}
.horizon {
  width: 91.5%;
  /* text-align: center;  */
  border-bottom: 1px solid #000;
  line-height: 0.1em;
  margin: 10px 100px 20px;
}

.back-arrow {
  position: relative;
  bottom: 37px;
  // padding: 0 20px;
}

@media only screen and (max-width: 450px) { 
  .horizon {
    width: 72%;
  }
}

@media only screen and (max-width: 850px) and (min-width: 500px) { 
  .horizon {
    width: 86%;
  }
}

@media only screen and (max-width: 1024px) and (min-width: 850px) { 
  .horizon {
    width: 90%;
  }
}
</style>
<script>
import { getLocalData,clearLocalData } from "@/utils/auth";
import $ from "jquery";
import moment from "moment";

export default {
  data() {
    return {
      image: require("@/assets/images/portrait/small/avatar-s-9.jpg"),
        buttonCss: {},
      textColor: {},
      style:[]
    };
  },
mounted(){
     let details = getLocalData();
    if(details.company_id)
    this.getCustomStyle(details.company_id);
},
  computed: {
    day() {
      return moment().format("dddd");
    },
    month() {
      return moment().format("MMMM");
    },
    day1() {
      return moment().format("D");
    },
    // getdate() {
    //   return moment().format("YYYY-MM-DD");
    // },
    current_date() {
      return moment().format("DD/MM/YYYY");
    },
  },
  methods: {
           getCustomStyle(id) {
   let data = {
          company_id: id,
        }; 
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          this.style=res.data.data;
          if (res.data.data.header_text)
            $(".header-text").html(res.data.data.header_text);
          if (res.data.data.footer_text)
            $(".footer-text").html(res.data.data.footer_text);

          $(".card-body").css({
            "background-color": res.data.data.form_background_color+ " !important",
          });
          $(
            "span.vfc-span-day.vfc-disabled.vfc-cursor-not-allowed.vfc-hover, .vfc-day, .vfc-top-date.vfc-center span, span.e-input-group-icon.e-ddl-icon.e-search-icon"
          ).css({ color: res.data.data.form_text_color });
          $(".vfc-arrow-right, .vfc-arrow-left").css({
            "border-color": res.data.data.form_text_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          let css = {
            color: this.textColor.color,
            "border-bottom-color": this.textColor.color,
          };
          $(".e-control-wrapper").css(css);
          $("span.e-input-group-icon.e-ddl-icon.e-search-icon").css(
            this.textColor
          );
          this.textColor = {
            color: res.data.data.form_text_color + " !important",
          };

          $(".the-footer p, .the-footer a").css({
            color: res.data.data.form_text_color,
          });

          this.buttonCss = {
            "background-color":
              res.data.data.button_background_color + "!important",
            "border-color":
              res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color+ "!important",
          };
        })
        .catch((error) => {
          this.$log.error(
            "File : BookingForm.vue | Function : getCustomStyle() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
     hasHistory () { return window.history.length > 2 }

  },
};
</script>